import { Checkbox as CheckboxChakra } from '@chakra-ui/react'
import { ChangeEvent } from 'react';

type CheckboxProps = {
    label?: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    size?: 'sm' | 'md' | 'lg';
}

const Checkbox = ({label, onChange, size='md'}: CheckboxProps) => {
    return (
    <CheckboxChakra size={size} color="#6F6F6F" onChange={onChange}>{label}</CheckboxChakra>
    );
}

export {Checkbox};